/* Iron Fit — tap-to-drop-pin map inside the EasySell COD order form.
   Tap / "locate me" -> reverse-geocode (BigDataCloud, keyless) -> fill #es-address
   ("locality | Pin: maps.google.com/?q=lat,lng") and select the matching #es-city region
   (matched by Lebanon ISO code, e.g. LB_BA). Leaflet + OpenStreetMap, no API key. */
(function () {
  "use strict";
  var LEAFLET_CSS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
  var LEAFLET_JS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
  var LB_CENTER = [33.8547, 35.8623];
  var VALID = { LB_AK: 1, LB_BH: 1, LB_BA: 1, LB_BI: 1, LB_JL: 1, LB_NA: 1, LB_AS: 1, LB_JA: 1 };

  function loadLeaflet(cb) {
    if (window.L) { cb(); return; }
    if (!document.querySelector('link[data-iflf-css]')) {
      var l = document.createElement("link");
      l.rel = "stylesheet"; l.href = LEAFLET_CSS; l.setAttribute("data-iflf-css", "1");
      document.head.appendChild(l);
    }
    var s = document.querySelector('script[data-iflf-js]');
    if (s) { s.addEventListener("load", cb); if (window.L) cb(); return; }
    s = document.createElement("script");
    s.src = LEAFLET_JS; s.setAttribute("data-iflf-js", "1");
    s.onload = cb; document.head.appendChild(s);
  }

  function nativeSet(el, val) {
    var proto = el.tagName === "SELECT" ? window.HTMLSelectElement.prototype
      : (el.tagName === "TEXTAREA" ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype);
    var desc = Object.getOwnPropertyDescriptor(proto, "value");
    if (desc && desc.set) { desc.set.call(el, val); } else { el.value = val; }
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function regionCode(d) {
    var code = (d.principalSubdivisionCode || "").toUpperCase().replace("-", "_");
    if (VALID[code]) return code;
    var names = [];
    if (d.localityInfo && d.localityInfo.administrative) {
      d.localityInfo.administrative.forEach(function (a) { if (a.name) names.push(a.name); });
    }
    var t = (names.join(" ") + " " + (d.principalSubdivision || "") + " " + (d.locality || "") + " " + (d.city || "")).toLowerCase();
    var rules = [
      ["beirut", "LB_BA"], ["beyrouth", "LB_BA"],
      ["akkar", "LB_AK"], ["aakkar", "LB_AK"],
      ["baalbek", "LB_BH"], ["hermel", "LB_BH"],
      ["beqaa", "LB_BI"], ["bekaa", "LB_BI"], ["zahl", "LB_BI"],
      ["nabati", "LB_NA"],
      ["mont-liban", "LB_JL"], ["mount lebanon", "LB_JL"], ["keserwan", "LB_JL"], ["kesrouan", "LB_JL"],
      ["jbeil", "LB_JL"], ["byblos", "LB_JL"], ["metn", "LB_JL"], ["baabda", "LB_JL"], ["aley", "LB_JL"],
      ["chouf", "LB_JL"], ["jounie", "LB_JL"], ["jabal", "LB_JL"],
      ["liban-nord", "LB_AS"], ["tripoli", "LB_AS"], ["koura", "LB_AS"], ["zghart", "LB_AS"],
      ["batroun", "LB_AS"], ["bcharr", "LB_AS"], ["minieh", "LB_AS"], ["danniyeh", "LB_AS"], ["north", "LB_AS"],
      ["liban-sud", "LB_JA"], ["saida", "LB_JA"], ["sidon", "LB_JA"], ["sour", "LB_JA"],
      ["tyre", "LB_JA"], ["jezzine", "LB_JA"], ["south", "LB_JA"]
    ];
    for (var i = 0; i < rules.length; i++) { if (t.indexOf(rules[i][0]) > -1) return rules[i][1]; }
    return null;
  }

  function setRegion(d) {
    var sel = document.querySelector("#es-city");
    if (!sel) return;
    var code = regionCode(d);
    if (!code || !VALID[code]) return;
    var opts = [].slice.call(sel.options);
    for (var k = 0; k < opts.length; k++) { if (opts[k].value === code) { nativeSet(sel, code); return; } }
  }

  function reverseGeocode(lat, lng) {
    var addr = document.querySelector("#es-address");
    if (addr && !addr.value) addr.setAttribute("placeholder", "Locating your address...");
    var link = "https://maps.google.com/?q=" + lat.toFixed(6) + "," + lng.toFixed(6);
    fetch("https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=" + lat + "&longitude=" + lng + "&localityLanguage=en")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var parts = [];
        [d.locality, d.city, d.principalSubdivision].forEach(function (v) { if (v && parts.indexOf(v) === -1) parts.push(v); });
        var human = parts.join(", ") || (d.countryName || "Selected location");
        if (addr) nativeSet(addr, human + " | Pin: " + link);
        setRegion(d);
      })
      .catch(function () { if (addr) nativeSet(addr, "Pinned location | Pin: " + link); });
  }

  function buildMap(wrap) {
    var mapDiv = wrap.querySelector(".iflf-map");
    var map = L.map(mapDiv, { scrollWheelZoom: false }).setView(LB_CENTER, 8);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19, attribution: "© OpenStreetMap" }).addTo(map);
    var marker = null;
    function setPin(lat, lng, fly) {
      if (!marker) {
        marker = L.marker([lat, lng], { draggable: true }).addTo(map);
        marker.on("dragend", function () { var p = marker.getLatLng(); setPin(p.lat, p.lng, false); });
      } else { marker.setLatLng([lat, lng]); }
      if (fly) map.setView([lat, lng], Math.max(map.getZoom(), 15));
      reverseGeocode(lat, lng);
    }
    map.on("click", function (e) { setPin(e.latlng.lat, e.latlng.lng, true); });
    wrap.querySelector(".iflf-locate").addEventListener("click", function (ev) {
      ev.preventDefault();
      if (!navigator.geolocation) { alert("Location not supported — tap the map to set your delivery pin."); return; }
      var b = ev.currentTarget, old = b.innerHTML;
      b.innerHTML = "Locating…";
      navigator.geolocation.getCurrentPosition(
        function (pos) { setPin(pos.coords.latitude, pos.coords.longitude, true); b.innerHTML = old; },
        function () { b.innerHTML = old; alert("Could not get your location — tap the map to set your delivery pin instead."); },
        { enableHighAccuracy: true, timeout: 9000, maximumAge: 0 }
      );
    });
    // Robust sizing: the EasySell form animates in, so recalc size several times + on resize.
    function fix() { map.invalidateSize(false); }
    [60, 250, 600, 1200, 2000].forEach(function (ms) { setTimeout(fix, ms); });
    if (window.ResizeObserver) { try { new ResizeObserver(fix).observe(mapDiv); } catch (e) {} }
    try { window.__ifMap = map; } catch (e) {}
  }

  function inject() {
    var addr = document.querySelector("#es-address");
    if (!addr || addr.getAttribute("data-iflf") === "1") return;
    addr.setAttribute("data-iflf", "1");
    var wrap = document.createElement("div");
    wrap.className = "iflf-wrap";
    wrap.setAttribute("style", "margin:6px 0 10px;");
    wrap.innerHTML =
      '<div class="iflf-hint" style="font-size:13px;color:#dc2626;font-weight:700;margin-bottom:4px;text-align:center;">📍 Tap the map to set your delivery location</div>' +
      '<div class="iflf-map" style="height:200px;border-radius:10px;overflow:hidden;border:1px solid #e2e2e2;"></div>' +
      '<button type="button" class="iflf-locate" style="width:100%;padding:9px;margin-top:6px;border:1px solid #16a34a;background:#f0fdf4;color:#16a34a;font-weight:700;border-radius:8px;cursor:pointer;">📍 Locate my current position</button>';
    var host = addr.closest(".es-field, .es-form-field, .es-input-group, .es-row") || addr.parentNode;
    (host.parentNode || host).insertBefore(wrap, host);
    loadLeaflet(function () { buildMap(wrap); });
  }

  var obs = new MutationObserver(function () { if (document.querySelector("#es-address")) inject(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  if (document.querySelector("#es-address")) inject();

  /* Handoff from the Build-Your-Gym builder: open the EasySell cart form and pre-fill it. */
  function ifHandoff() {
    var params = new URLSearchParams(location.search);
    if (params.get("ifcod") !== "1") return;
    var raw; try { raw = sessionStorage.getItem("IFCOD"); } catch (e) { raw = null; }
    if (!raw) return;
    var d; try { d = JSON.parse(raw); } catch (e) { return; }
    var tries = 0;
    function isOpen() { var el = document.querySelector("#es-first_name"); return !!(el && el.offsetParent !== null && el.getBoundingClientRect().width > 0); }
    var iv = setInterval(function () {
      tries++;
      if (!isOpen()) {
        // click the cart COD button to actually OPEN the popup (a few spaced retries)
        if (tries === 1 || tries === 6 || tries === 12 || tries === 20 || tries === 30) {
          var b = document.querySelector(".es-popup-button-cart") || document.querySelector(".es-popup-button");
          if (b) b.click();
        }
        if (tries > 70) clearInterval(iv);
        return;
      }
      var name = document.querySelector("#es-first_name"), phone = document.querySelector("#es-phone"),
        addr = document.querySelector("#es-address"), city = document.querySelector("#es-city");
      if (name && addr) {
        if (d.name) nativeSet(name, d.name);
        if (d.phone && phone) nativeSet(phone, d.phone);
        var av = (d.addr || ""); if (d.gps) av += " | Pin: " + d.gps; if (d.build) av += " || " + d.build;
        nativeSet(addr, av);
        if (d.region && city) { for (var i = 0; i < city.options.length; i++) { if (city.options[i].value === d.region) { nativeSet(city, d.region); break; } } }
        try { sessionStorage.removeItem("IFCOD"); } catch (e) {}
      }
      clearInterval(iv);
    }, 300);
  }
  ifHandoff();
})();
